<template>
    <div class="my-8 flex">
        <div class="flex-none">
            <span
                :class="
                    currentPage !== 1
                        ? 'btn btn-primary btn-sm'
                        : 'btn btn-primary btn-sm btn-disabled'
                "
                v-on:click="prevPage()"
                ><i class="fa fa-arrow-left"></i> Previous</span
            >
        </div>
        <div class="flex-grow text-center text-[14px] text-neutral-60">
            <span v-if="lastPage > 1">
                Page <strong>{{ currentPage }}</strong> of
                <strong>{{ lastPage }}</strong> Pages
            </span>
        </div>
        <div class="flex-none">
            <span
                :class="
                    currentPage !== lastPage
                        ? 'btn btn-primary btn-sm'
                        : 'btn btn-primary btn-sm btn-disabled'
                "
                v-on:click="nextPage()"
                >Next <i class="fa fa-arrow-right"></i
            ></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Pagination",
    emits: ["next-page", "prev-page"],
    props: {
        currentPage: {
            type: Number,
            default: 1,
        },
        lastPage: {
            type: Number,
            default: 1,
        },
        totalItems: {
            type: Number,
            default: 0,
        },
    },
    methods: {
        nextPage: function () {
            if (this.currentPage < this.lastPage) {
                this.$emit("next-page");
            }
        },
        prevPage: function () {
            if (this.currentPage > 1) {
                this.$emit("prev-page");
            }
        },
    },
};
</script>

<style scoped></style>
